import React from "react";
import "./styles/common.less";
import {
  Routes,
  Route,
  BrowserRouter,
  Navigate,
} from "react-router-dom";
import IndexLayout from "./layout/";
import WorkspaceHome from "./pages/_workspace/Home";
import Login from "./pages/login";
import WorkspaceRegister from "./pages/_workspace/Register";
import WorkspaceDetail from "./pages/_workspace/Detail";
import NewComplaint from "./pages/newComplaint"
import NewComplaintDetail from "./pages/newComplaintDetail";
import PermissionManage from "./pages/permissionManage";
import MyPermissions from "./pages/myPermissions";
import IdentitySelect from "./pages/identitySelect";
import DataServiceRedirect from "./pages/dataServiceRedirect";
import NoAccessPage from "./pages/noAccess";
import ModuleGuard from "./components/ModuleGuard";
import IdentityGuard from "./components/IdentityGuard";

import Complaint from "./pages/complaint";
import ComplaintDetail from "./pages/complaint _detail";

import { ConfigProvider } from "antd";
import zhCN from 'antd/locale/zh_CN';

const App = () => {
  return (
    <ConfigProvider locale={zhCN}>
      <div className="wrapper">
        <BrowserRouter>
          <Routes>
            <Route path="/view" element={<IndexLayout />}>
              <Route path="home" element={<ModuleGuard requiredPermission="app_management"><WorkspaceHome /></ModuleGuard>}></Route>
              <Route path="complaint_center" element={<ModuleGuard requiredPermission="complaint_handling"><NewComplaint /></ModuleGuard>}></Route>
              <Route path="newComplaintDetail/:id" element={<ModuleGuard requiredPermission="complaint_handling"><NewComplaintDetail /></ModuleGuard>}></Route>
              <Route path="permission_manage" element={<IdentityGuard requiredIdentity="owner"><PermissionManage /></IdentityGuard>}></Route>
              <Route path="my_permissions" element={<MyPermissions />}></Route>
              <Route path="identity_select" element={<IdentitySelect />}></Route>
              <Route path="data_service_redirect" element={<ModuleGuard requiredPermission="data_service"><DataServiceRedirect /></ModuleGuard>}></Route>
              <Route path="no_access" element={<NoAccessPage />}></Route>
              {/* <Route path="complaint_center" element={<Complaint />}></Route>
              <Route path="complaint/:id" element={<ComplaintDetail />}></Route> */}
              <Route path="detail/:id" element={<ModuleGuard requiredPermission="app_management"><WorkspaceDetail /></ModuleGuard>}></Route>
              <Route path="register/add" element={<WorkspaceRegister />}></Route>
              <Route path="register/:id" element={<WorkspaceRegister />}></Route>
            </Route>
            <Route path="/login" element={<Login />}></Route>
            <Route path="*" element={<Navigate to="/view/home" replace />} />
          </Routes>
        </BrowserRouter>
      </div>
    </ConfigProvider>
  );
};

export default App;
